import React, {Component} from 'react';
import {Modal} from "antd";
import {injectIntl} from "react-intl";
import SAInputLabel from "../../common/input/SAInputLabel";
import {connect} from "react-redux";
import {getCamelCaseType} from "../WheelsExchangeUtils";

class PlanningSlotAddModal extends Component {

  constructor(props) {
    super(props);
    this.state = {
      customer: {},
      errors: {}
    }
  }

  componentWillReceiveProps(nextProps, nextContext) {
    if (nextProps.updateWheelsExchangeSlots && nextProps.updateWheelsExchangeSlots.error) {
      // handle error in this lifecycle to prevent modal to open with previous errors
      this.setState({errors: nextProps.updateWheelsExchangeSlots.error.content || {}});
    }
  }

  onInputChange = e => {
    const {customer} = this.state;
    const {target: {name, value}} = e;
    customer[name] = value ;
    this.setState({customer});
  };

  onAddClick = () => {
    const {slot} = this.props;
    const {customer} = this.state;
    this.props.onUpdate({
      ...slot,
      customers: [...(slot.customers || []), customer]
    });
  };

  onModalClose = () => {
    this.props.dispatchShowWheelsExchangeAddModal(false);
  };

  render() {
    const {intl: {formatMessage}, updateWheelsExchangeSlots: {loading}, slot} = this.props;
    const {customer: {firstName, lastName, phoneNumber, plate, brand, model}, errors} = this.state;
    const customerIndex = slot.customers && slot.customers.length;

    return (
      <Modal
        title={formatMessage({id: 'section.exchange-management.modal.show'})}
        visible={true} // visibility is handled in parent's component to allow demount
        onCancel={this.onModalClose}
        onOk={this.onAddClick}
        confirmLoading={loading}
        width={800}
      >
        <h3 className="box__subtitle">{formatMessage({id:'customer.details.title'})}</h3>
        <div className="row">
          <div className="col-md-6 col-xxl-6">
            <SAInputLabel label={'customer.firstname'} name="firstName" value={firstName} onChange={this.onInputChange}
                          error={errors[`customers[${customerIndex}].firstName`]}
            />
            <SAInputLabel label={'summary.phone'} name="phoneNumber" value={phoneNumber} onChange={this.onInputChange}
                          error={errors[`customers[${customerIndex}].phoneNumber`]}
            />
          </div>
          <div className="col-md-6 col-xxl-6">
            <SAInputLabel label={'customer.lastname'} name="lastName" value={lastName} onChange={this.onInputChange}
                          error={errors[`customers[${customerIndex}].lastName`]}
            />
          </div>
        </div>

        <h3 className="box__subtitle">{formatMessage({id:'car-information.detailed.title'})}</h3>
        <div className="row">
          <div className="col-md-6 col-xxl-6">
            <SAInputLabel label={'vehicle.make'} name="brand" value={brand} onChange={this.onInputChange}
                          error={errors[`customers[${customerIndex}].brand`]}
            />
            <SAInputLabel className={"uppercase"} label={'vehicle.plate'} name="plate" value={plate} onChange={this.onInputChange}
                          error={errors[`customers[${customerIndex}].plate`]}
            />
          </div>
          <div className="col-md-6 col-xxl-6">
            <SAInputLabel label={'vehicle.model'} name="model" value={model} onChange={this.onInputChange}
                          error={errors[`customers[${customerIndex}].model`]}
            />
          </div>
        </div>
      </Modal>
    )
  }
}

const mapStateToProps = (state, ownProps)=> {
  const camelCaseType = getCamelCaseType(ownProps.type);
  const updateWheelsExchangeSlots = state[`update${camelCaseType}ExchangeCustomers`];
  return {updateWheelsExchangeSlots};
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  dispatchShowWheelsExchangeAddModal: show => dispatch({type: `SHOW_${ownProps.type}_EXCHANGE_SLOT_ADD_MODAL`, show}),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(PlanningSlotAddModal));



// WEBPACK FOOTER //
// ./src/components/wheelsexchange/management/PlanningSlotAddModal.js